/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Brands Web API v2
 * OpenAPI spec version: v2
 */

export type TwoFactorAuthDetailsSchemaMfaEnforcementState = typeof TwoFactorAuthDetailsSchemaMfaEnforcementState[keyof typeof TwoFactorAuthDetailsSchemaMfaEnforcementState];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TwoFactorAuthDetailsSchemaMfaEnforcementState = {
  Off: 0,
  Grace: 1,
  Enforced: 2,
} as const;
